import React /* , { useState, useEffect, useRef } */ from "react"
import { ThemeProvider } from "@mui/material/styles"
import muiTheme from "../../configs/muiTheme"
import styled from "styled-components"
import Navbar from "./Navbar"
import Footer from "./Footer"
import ButtonScrollToTop from "../common/buttons/ButtonScrollToTop"
// import {
//   CONSENT_COOKIE_NAME,
//   CookiesConsent,
// } from "../common/cookiesConsent/CookiesConsent"
// import Cookies from "js-cookie"
/* import { showContainer } from '../../configs/animations' */

const Layout = ({ children }) => {
  /* const [playAnimation, setPlayAnimation] = useState(false)
  const containerContent = useRef(null)

  useEffect(() => {
    const onPageLoad = () => {
      setPlayAnimation(true)
    }

    if (document.readyState === 'complete') {
      onPageLoad()
    } else {
      window.addEventListener('load', onPageLoad)
      return () => window.removeEventListener('load', onPageLoad)
    }
    if (playAnimation) {
      showContainer(containerContent)
    }
  }, [playAnimation]) */

  // if (typeof window !== "undefined") {
  //   require("smooth-scroll")('a[href*="#"]')
  // }
  return (
    <>
      <ThemeProvider theme={muiTheme}>
        <Navbar />
        <div className="overlay"></div>
        <AnimationWrapper /* ref={containerContent} */>
          <ChildrenWrapper>{children}</ChildrenWrapper>
        </AnimationWrapper>
        <Footer />
        {/*{!Cookies.get(CONSENT_COOKIE_NAME) ? <CookiesConsent /> : null}*/}
        <ButtonScrollToTop />
      </ThemeProvider>
    </>
  )
}

export default Layout

const ChildrenWrapper = styled.div`
  min-height: 85vh;
`

const AnimationWrapper = styled.div`
  /* visibility: hidden; */
`
